<div class="div-estreita">
    <app-painel1-confeccao
            [ludSelecionado]="ludSelecionado"
            [bancoRecursos]="bancoRecursos"
            [isGerirRecursos]="isGerirRecursos"
            (ludConfirmado)="ludConfirmado.emit($event)">
    </app-painel1-confeccao>
</div>
<div class="secao-tela">
    Pesquisa
    <div class="opcao" [class]="filtroPesquisa.tipoPesquisa===1?'selecionada':null" (click)="selecionarTipoPesquisa(1)">
        <img src="/favicon-normas.ico"class="icon-normas">
        Atos e LUDs Normas
    </div>
    <div class="opcao" [class]="filtroPesquisa.tipoPesquisa===2?'selecionada':null" (click)="selecionarTipoPesquisa(2)">
        <em class="material-icons icon-18">language</em>
        LUDs internet
    </div>
    <div class="opcao" [class]="filtroPesquisa.tipoPesquisa===3?'selecionada':null" (click)="selecionarTipoPesquisa(3)">
        Todo o banco de LUDs
    </div>
</div>
<div class="div-estreita" *ngIf="exibirPesquisa">
    <app-painel2-pesquisa
        [filtroPesquisa]="filtroPesquisa"
        [bancoRecursos]="bancoRecursos"
        [cacheDominios]="cacheDominios"
        (aoPesquisar)="publicarResultado($event)">
    </app-painel2-pesquisa>
</div>
<div class="secao-tela clicavel" (click)="exibirResultado = !exibirResultado" [class]="(!recursos || recursos.length === 0) ? 'inativo' : null">
    Resultado
</div>
<div class="div-estreita" *ngIf="exibirResultado">
    <app-painel3-resultado
        [recursos]="recursos"
        [bancoRecursos]="bancoRecursos"
        [tipoPesquisa]="filtroPesquisa.tipoPesquisa"
        [isGerirRecursos]="isGerirRecursos"
        (dispositivoSelecionado)="selecionarDispositivo($event)"
        (selecionarRecurso)="selecionarRecurso($event)"
        (atualizarRecursos)="publicarResultado($event)">
    </app-painel3-resultado>
    <ng-container *ngIf="!recursos || recursos.length === 0">
        Nenhum resultado a exibir.
    </ng-container>
</div>

<div class="secao-tela" [class]="(exibirCadastro) ? null : 'inativo'" (click)="exibirCadastro = false">
    Cadastro no banco de LUDs
    <div class="opcao-botao" (click)="incluirLUDInternet($event)">Incluir LUD de internet</div>
</div>

<div class="div-estreita" [style.display]="exibirCadastro?'block':'none'">
    <app-painel4-cadastro
        [bancoRecursos]="bancoRecursos"
        (dispositivoSelecionado)="selecionarDispositivo($event)"
        (atualizarRecursoSelecionado)="atualizarRecursoSelecionado($event)">
    </app-painel4-cadastro>
</div>
